export default __webpack_public_path__ + "navigation-examples-advanced-v1-1200-3fe09a8f2e4fc65e7b21a0f04134552a.png";